/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="3.5" y="6.5" width="12" height="17" />
      <path d="M3.5,16.5 L0.5,16.5 L0.5,3.5 C0.5,1.843 1.843,0.5 3.5,0.5 C5.157,0.5 6.5,1.843 6.5,3.5 C6.5,5.157 5.157,6.5 3.5,6.5 L3.5,4.5 L6.292,4.5" />
      <path d="M15.5,6.5 C17.157,6.5 18.5,5.157 18.5,3.5 C18.5,1.843 17.157,0.5 15.5,0.5 L3.5,0.5" />
      <path d="M9.5,10.5 L13.5,10.5" />
      <path d="M9.5,14.5 L13.5,14.5" />
      <path d="M9.5,18.5 L13.5,18.5" />
      <polyline points="5.5 10 6 10.5 8 8.5" />
      <polyline points="5.5 14 6 14.5 8 12.5" />
      <path d="M23.5,22 C23.5,22.829 22.828,23.5 22,23.5 C21.172,23.5 20.5,22.829 20.5,22 L20.5,7.5 C20.5,6.672 21.172,6 22,6 C22.828,6 23.5,6.672 23.5,7.5 L23.5,22 Z" />
      <path d="M20.5,21.5 L23.5,21.5" />
      <path d="M20.5,14.5 L23.5,14.5" />
      <path d="M18.5,16 L18.5,8.5 C18.5,7.672 19.172,7 20,7 L20.586,7" />
    </g>
  </svg>
);

export default Icon;
